export default __webpack_public_path__ + "static/media/505.33ec7d96.png";